import Api from "../utils/axios";

export const chatApi = {
  getAllUserStatus: () => Api.get("/get/status"),
  getAllUsers: () => Api.get("/user/all"),
  uploadFiles: (payload, options) => Api.post(`/upload`, payload, options),
};
